import {AsyncContainerModule, interfaces} from "inversify";
import {eventBusTypes} from "./types";
import {MittEventBus} from "../adapters";
import {EventBus} from "../eventBus";

export default new AsyncContainerModule(async (bind: interfaces.Bind, unbind: interfaces.Unbind) => {
  bind<EventBus>(eventBusTypes.EventBus).to(MittEventBus).inSingletonScope();
});
